import React, { Component } from "react";
import { Helmet } from "react-helmet";

import InvoiceList from "./batchTransactions/InvoicesList";
import auth from "../../../services/authService";
import EntityContext from "../../../context/entityContext";

class BatchSalesInvoices extends Component {
  static contextType = EntityContext;
  constructor(props) {
    super(props);
  }

  state = {
    selectedTab: this.props.location.state ? this.props.location.state : null,
    ajaxRequest: false,
    selectedRows: [],
    categories: [],
    open: false,
    openCustomer: false,
    approvebuttonClass: "btn btn-primary  hidden",
    declinebuttonClass: "btn btn-danger  hidden",
    bulkapprove: false,
    bulkreject: false,
    selected: {},
    roleType: "Sale",
    tabs: [],
    checkbox: true,
  };

  render() {
    const { constants } = auth.getCurrentUser();

    return (
      <>
        <Helmet>
          <title>Invoice List| {global.config.title}</title>
        </Helmet>


        {this.context.selProduct == constants.PRODUCTS.DEBTORFINANACE && (
          <InvoiceList type={this.props.location.query.type} />
        )}
      </>
    );
  }
}
export default BatchSalesInvoices;
